import Router from 'next/router'
import Link from 'next/link'
import { getStandaloneName } from 'utils/standalone'
import { popStoredUri } from '../client/store'

export function routeAfterLogin(router) {
  const { pathWithQuery, asPath } = popStoredUri()
  if (pathWithQuery && asPath) return router.push(pathWithQuery, asPath)
  return router.push('/standalone/home', '/home')
}

const CustomRouter = {
  pushRoute: (pathName, query = {}, options = {}) => {
    const path = routeKeys[pathName]
    const v = path.match(/:[a-zA-Z]+/g)
    let urlPathname = path
    let asPathname = path

    if (v)
      v.forEach(v => {
        const key = v.substr(1)
        urlPathname = urlPathname.replace(`:${key}`, `[${key}]`)
        asPathname = asPathname.replace(`:${key}`, query[key])
        delete query[key]
      })

    if (getStandaloneName())
      return Router.push(
        { pathname: '/standalone' + urlPathname, query },
        { pathname: asPathname, query },
        options
      )

    return Router.push(
      { pathname: urlPathname, query },
      { pathname: asPathname, query },
      options
    )
  },
  push(path) {
    Router.push.call(arguments)
  },
}

export { CustomRouter as Router, Link }

const routeKeys = {
  root: '/',
  login: '/login',
  resetPassword: '/resetPassword',

  signup: '/signup',
  signupWithEmail: '/signup/email',
  registerProfile: '/signup/profile',
  verifyEmail: '/signup/verifyEmail',

  logout: '/logout',

  artist: '/artists/:name',
  artistSubscribe: '/artists/:name/subscribe',

  search: '/s/:word',
  searchNoWord: '/s',

  item: '/items/:id',
  serialItem: '/items/:id/serials/:serialId',
  completePurchase: '/items/:id/complete',

  portfolios: '/portfolios',
  portfolio: '/portfolios/:id',
  portfolioResource: '/portfolios/:id/resource',

  post: '/posts/:id',

  account: '/account',
  accountPayment: '/account/payment',
  accountEmail: '/account/email',
  accountPassword: '/account/password',
  accountProfile: '/account/profile',
  accountSubscription: '/account/subscription',
  purchaseHistory: '/account/purchaseHistory',

  artistDashboard: '/artist/dashboard',
  artistSignUp: '/artist/signup',
  artistLogin: '/artist/login',
  artistAccount: '/artist/account',
  artistAccountEmail: '/artist/account/email',
  artistAccountPassword: '/artist/account/password',
  artistAccountProfile: '/artist/account/profile',
  artistAccountBank: '/artist/account/bank/register',
  artistAccountBusiness: '/artist/account/business/register',
  artistPosts: '/artist/posts',
  artistPost: '/artist/posts/:id',
  newPost: '/artist/posts/new',
  sales: '/artist/sales',
  salesHistory: '/artist/sales/history',
  resources: '/artist/resources',
  resource: '/artist/resources/:id',
  store: '/artist/items',
  orderHistory: '/artist/orderHistory',
  newItem: '/artist/items/new',
  artistItem: '/artist/items/:id',
  editItem: '/artist/items/:id/edit',
  itemOwners: '/artist/items/:itemId/owners',

  admin: '/admin',
  adminArtists: '/admin/artists',
  adminArtistNew: '/admin/artists/new',
  adminArtist: '/admin/artists/:id',
  adminArtistEdit: '/admin/artists/:id/edit',
  adminArtistMissionNew: '/admin/artists/:id/missions/new',
  adminItems: '/admin/items',
  adminItem: '/admin/items/:id',
  adminGachas: '/admin/gachas',
  adminGachaNew: '/admin/gachas/new',
  adminGacha: '/admin/gachas/:id',
  adminGachaEdit: 'admin/gachas/:id/edit',
  adminGachaTickets: '/admin/gachaTickets',
  adminGachaTicketGive: '/admin/gachaTickets/give/:id',
  userDetail: '/users/:id',

  profile: '/profile',
  profileSetting: '/profile/setting',
  collections: '/collections',
  collection: '/collections/:id',
  missions: '/missions',
  mission: '/missions/:id',
  gacha: '/gachas',
  gachaTickets: '/gachaTickets/:id/serials/:serialId',
  gachaTicket: '/gachaTickets/:id',
}
